import { Stack } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React from 'react'
import NewPhotoUploadForm from './NewPhotoUploadForm'

function PhotosUpload({
  photoSettings,
  title,
  collection,
  setFile,
  deleteFile,
}: any) {
  return (
    <Box my={2}>
      {title ? <Typography variant={'body1'}>{title}</Typography> : null}
      <Stack mt={2} direction={'column'} spacing={1.5}>
        {collection?.map((image: any, i: number) => (
          <NewPhotoUploadForm
            key={i}
            image={image}
            collection={collection ?? []}
            setImage={setFile}
            deleteImage={deleteFile}
          />
        ))}
        {collection.length < photoSettings.maxLimitPerLoad && (
          <NewPhotoUploadForm
            collection={collection ?? []}
            setImage={setFile}
            deleteImage={deleteFile}
          />
        )}
      </Stack>
    </Box>
  )
}

export default observer(PhotosUpload)
